export enum ZPrinterPaperSize {
  MM80 = 'mm80',
  MM57 = 'mm57',
}
